import React from "react";

const
  AppHub = ( props: any ) => {
    return (
      <div>
        App Hub
      </div>
    );
  };

export default AppHub;